var _dec, _dec2, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import { classNames, layout as templateLayout } from '@ember-decorators/component';
import Component from '@ember/component';
import layout from '../templates/components/fly-dropdown-search-input';
import { DOWN, ENTER, ESCAPE, TAB, UP } from '@customerio/fly-components/utils/keyboard-support';

/**
  The reusable input element for searchable dropdowns.

  @class FlyDropdownSearchInput
  @public
 */
let FlyDropdownSearchInput = (_dec = classNames('fly-dropdown-search-input'), _dec2 = templateLayout(layout), _dec(_class = _dec2(_class = (_class2 = class FlyDropdownSearchInput extends Component {
  constructor(...args) {
    super(...args);
    /**
      The value for the input. This is managed by a parent component.
       @attribute value
      @type string
     */
    _defineProperty(this, "value", '');
    /**
      The placeholder for the input when no value is present.
       @attribute placeholder
      @type string
     */
    _defineProperty(this, "placeholder", 'Search...');
  }
  onKeyDownAction(event) {
    let key = event.which;
    if (key === ENTER) {
      this.onEnterPressed();
      event.preventDefault();
      return false;
    }
    if (key === ESCAPE || key === TAB) {
      this.collapseAction();
      return;
    }
    if (key === DOWN || key === UP) {
      event.preventDefault();
      this.onKeyDown(event);
    }
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "onKeyDownAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onKeyDownAction"), _class2.prototype)), _class2)) || _class) || _class);
export { FlyDropdownSearchInput as default };